<div>
  <app-common-chart
    [chartDataUrl]="mainChartDataUrl"
    [chartSettings]="mainChartSettings"
    [chartGradientProps]="mainChartGradientProps"
    class="d-block panel-header panel-header-lg"
  ></app-common-chart>
</div>
<div class="main-content views-container">
  <div class="row">
    @for (cardWithProps of cards; track cardWithProps) {
      <div class="col-lg-4 dashboard-card">
        @switch (cardWithProps.card.type) {
          <!-- <app-dashboard-card
          *ngSwitchCase="'GRAPH'"
          [cardParams]="cardWithProps.cardParams"
          >
          <app-common-chart
            [chartDataUrl]="cardWithProps.card.cardDataUrl"
            [chartSettings]="cardWithProps.chartOptions"
            [chartGradientProps]="cardWithProps.chartGradientProps"
            [chartType]="cardWithProps.chartType"
            class="d-block chart-area"
            body
            >
          </app-common-chart>
          <div class="stats" footer>
            <i class="now-ui-icons arrows-1_refresh-69"></i>
            {{ 'BO_UPDATED' | translate }}
          </div>
        </app-dashboard-card> -->
        @case ('GRAPH') {
          <div
            class="card card-chart common-card overflow-auto"
            >
            <div class="card-header">
              <h5 class="card-category">
                {{ cardWithProps.cardParams.category | translate }}
              </h5>
              <h4 class="card-title">
                {{ cardWithProps.cardParams.title | translate }}
              </h4>
            </div>
            <div class="card-body">
              <app-common-chart
                [chartDataUrl]="cardWithProps.card.cardDataUrl"
                [chartSettings]="cardWithProps.chartOptions"
                [chartGradientProps]="cardWithProps.chartGradientProps"
                [chartType]="cardWithProps.chartType"
                class="d-block chart-area"
                body
                >
              </app-common-chart>
            </div>
            <div class="card-footer">
              <div class="stats" footer>
                <i class="now-ui-icons arrows-1_refresh-69"></i>
                {{ 'BO_UPDATED' | translate }}
              </div>
            </div>
          </div>
        }
        @case ('LIST') {
          <div class="card overflow-auto">
            <app-dynamic-list-data
              [title]="cardWithProps.card.title | translate"
              [cellProps]="cardWithProps.cellProps"
              [sourceUrl]="cardWithProps.card.cardDataUrl"
            ></app-dynamic-list-data>
          </div>
        }
      }
    </div>
  }
</div>
</div>
